// DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    let mm = gsap.matchMedia();

    const accordionInstances = document.querySelectorAll('.accordion');
    const accordionStory = document.getElementById('accordion-story');
    const almBlock = document.querySelector('.ajax-load-more-wrap');
    const containerTeam = document.getElementById('container-team');
    const header = document.getElementById('header');
    const logo = document.getElementById('logo');
    //const masonryBlock = document.querySelector('.listing-masonry');
    //const masonryProjects = document.querySelector('.listing-projects');
    const menuBg = document.getElementById('menu-bg');
    const menuContainer = document.getElementById('menu-container');
    const menuSecondary = document.getElementById('menu-secondary');
    const menuToggle = document.getElementById('menu-toggle');
    const modalBg = document.getElementById('modal-bg');
    const modalTeam = document.getElementById('modal-team');
    const params = new URLSearchParams(window.location.search);

    // ---------------------------------------------------------------------------------------------------- Calculations

    const recalcHeightItems = document.querySelectorAll('.recalc-height');
    const recalcWidthItems = document.querySelectorAll('.recalc-width');

    function recalcHeight() {
        recalcHeightItems.forEach((el) => {
            el.style.setProperty('--recalc-my-height', el.offsetHeight + 'px');
        });

        document
            .querySelector('body')
            .style.setProperty(
                '--recalc-window-height',
                window.innerHeight + 'px'
            );

        document
            .querySelector('body')
            .style.setProperty(
                '--recalc-header-height',
                header.offsetHeight + 'px'
            );
    }

    function recalcWidth() {
        recalcWidthItems.forEach((el) => {
            el.style.setProperty('--recalc-my-width', el.offsetWidth + 'px');
        });

        document
            .querySelector('body')
            .style.setProperty(
                '--recalc-window-width',
                window.innerWidth + 'px'
            );
    }

    recalcHeight();
    recalcWidth();

    window.addEventListener('resize', recalcHeight, false);
    window.addEventListener('resize', recalcWidth, false);

    // ---------------------------------------------------------------------------------------------------- Functions

    function indexInParent(node) {
        var children = node.parentNode.childNodes;
        var num = 0;
        for (var i = 0; i < children.length; i++) {
            if (children[i] == node) return num;
            if (children[i].nodeType == 1) num++;
        }
        return -1;
    }

    function refreshMasonry() {
        // Using var because let doesn't work
        /*
        if (masonryBlock) {
            var masonryBlockItems = Masonry.data(masonryBlock);
            masonryBlockItems.reloadItems();
            masonryBlockItems.layout();
        }
        */
        /*
        if (masonryProjects) {
            var masonryProjectsItems = Masonry.data(masonryProjects);
            masonryProjectsItems.reloadItems();
            masonryProjectsItems.layout();
        }
        */
        // Force resize event so Masonry recalculates its height, prevents scroll animations not working correctly
        window.dispatchEvent(new Event('resize'));
    }

    function scrollYRestore() {
        // If the menu button is not active after toggling, refresh masonry, restore scroll position, clear data attribute
        if (!menuToggle.classList.contains('active')) {
            refreshMasonry();
            window.scrollTo(
                0,
                parseInt(document.querySelector('html').dataset.scrolly)
            );
            document.querySelector('html').dataset.scrolly = '';
        }
    }

    function scrollYSave() {
        // If the menu button is active after toggling, store the scroll position
        if (menuToggle.classList.contains('active')) {
            document.querySelector('html').dataset.scrolly = window.scrollY;
        }
    }

    function scrollToAnchor() {
        if (document.querySelector('html').dataset.anchor) {
            document
                .querySelector(document.querySelector('html').dataset.anchor)
                .scrollIntoView({
                    behavior: 'smooth',
                });
            document.querySelector('html').dataset.anchor = ''; // Clear data attribute so it doesn't scroll on every ALM load
        }
    }

    function toggleButtonMenu() {
        logo.classList.toggle('tw--translate-y-40');

        menuToggle.classList.toggle('active');
        menuToggle.classList.toggle('tw-bg-black');
        menuToggle.classList.toggle('tw-bg-gunmetal');

        menuToggle.querySelectorAll('span').forEach((el) => {
            el.classList.toggle('tw-bg-coral');
            el.classList.toggle('tw-bg-white');
        });

        menuToggle
            .querySelectorAll('span:first-child,span:last-child')
            .forEach((el) => {
                el.classList.toggle('tw-opacity-0');
                el.classList.toggle('tw-scale-0');
            });

        menuToggle
            .querySelector('span:nth-child(2)')
            .classList.toggle('tw--rotate-45');

        menuToggle
            .querySelector('span:nth-child(3)')
            .classList.toggle('tw-rotate-45');
    }

    function toggleModalTeam() {
        modalBg.classList.toggle('tw-hidden');
        modalTeam.classList.toggle('active');
        modalTeam.classList.toggle('tw-hidden');
    }

    function togglePageContent() {
        document.querySelectorAll('main,footer').forEach((el) => {
            // Removing from document flow and throwing off-screen is preferable to hiding (doesn't break Masonry)
            el.classList.toggle('tw-absolute');
            el.classList.toggle('tw-bottom-full');
        });
    }

    let lastScrollY = window.scrollY;

    function togglePageHeaderState() {
        header.classList.toggle('header-scrolled', window.scrollY > 1);

        header.classList.toggle(
            'header-scrolled-down',
            window.scrollY > window.innerHeight
        );

        if (window.scrollY < lastScrollY) {
            header.classList.remove('header-scrolled-down');
        }

        lastScrollY = window.scrollY;
    }

    // ---------------------------------------------------------------------------------------------------- GSAP

    mm.add('(prefers-reduced-motion: no-preference)', () => {
        // Menu animation
        if (menuToggle) {
            gsap.set('#menu-backslash', { opacity: 0, x: 50 });
            gsap.set('#menu-bg', { opacity: 0 });
            gsap.set('#menu-contact', { opacity: 0 });
            gsap.set('#menu-container', { opacity: 0 });
            gsap.set('#menu-primary > li', { opacity: 0, y: 50 });
            if (menuSecondary) {
                gsap.set('.menu-secondary', { opacity: 0 });
            }
            gsap.set('#social-header', { opacity: 0 });
        }
        // Team modal animation
        if (modalTeam) {
            gsap.set('#modal-bg', { opacity: 0 });
            gsap.set('#modal-team', { opacity: 0 });
            gsap.set('#modal-team-awards', { opacity: 0, y: 50 });
            gsap.set('#modal-team-bio', { opacity: 0, y: 50 });
            gsap.set('#modal-team-education', { opacity: 0, y: 50 });
            gsap.set('#modal-team-image', { opacity: 0, scale: 0.5 });
            gsap.set('#modal-team-name', { opacity: 0, y: 50 });
            gsap.set('#modal-team-position', { opacity: 0, y: 50 });
        }
    });

    // Menu animation

    const showMenu = gsap.timeline({ paused: true });

    if (menuToggle) {
        showMenu.to('#menu-bg', {
            duration: 0.3,
            ease: 'circ.out',
            opacity: 1,
        });
        showMenu.add(function () {
            togglePageContent();
            togglePageHeaderState();
        });
        showMenu.to(
            '#menu-container',
            {
                duration: 0.3,
                ease: 'circ.out',
                opacity: 1,
            },
            '-=0.3'
        );
        showMenu.to('#menu-primary > li', {
            duration: 0.75,
            ease: 'circ.out',
            opacity: 1,
            stagger: 0.1,
            y: 0,
        });
        if (menuSecondary) {
            showMenu.to(
                '.menu-secondary',
                {
                    duration: 0.5,
                    ease: 'circ.out',
                    opacity: 1,
                },
                '-=0.25'
            );
        }
        showMenu.to(
            '#menu-backslash',
            {
                duration: 0.5,
                ease: 'circ.out',
                opacity: 1,
                x: 0,
            },
            '-=0.5'
        );
        showMenu.to(
            '#menu-contact',
            {
                duration: 0.5,
                ease: 'circ.out',
                opacity: 1,
            },
            '-=0.5'
        );
        showMenu.to(
            '#social-header',
            {
                duration: 0.5,
                ease: 'circ.out',
                opacity: 1,
            },
            '-=0.5'
        );
    }

    // Team modal animation

    const showModalTeam = gsap.timeline({ paused: true });

    if (modalTeam) {
        showModalTeam.to('#modal-bg', {
            duration: 0.3,
            ease: 'circ.out',
            opacity: 1,
        });
        showModalTeam.add(function () {
            togglePageContent();
            togglePageHeaderState();
        });
        showModalTeam.to(
            '#modal-team',
            {
                duration: 0.3,
                ease: 'circ.out',
                opacity: 1,
            },
            '-=0.3'
        );
        showModalTeam.to('#modal-team-image', {
            duration: 0.75,
            ease: 'circ.out',
            opacity: 1,
            scale: 1,
        });
        showModalTeam.to(
            '#modal-team-name',
            {
                duration: 0.5,
                ease: 'circ.out',
                opacity: 1,
                y: 0,
            },
            '-=0.5'
        );
        showModalTeam.to(
            '#modal-team-position',
            {
                duration: 0.5,
                ease: 'circ.out',
                opacity: 1,
                y: 0,
            },
            '-=0.25'
        );
        showModalTeam.to(
            '#modal-team-education',
            {
                duration: 0.5,
                ease: 'circ.out',
                opacity: 1,
                y: 0,
            },
            '-=0.25'
        );
        showModalTeam.to(
            '#modal-team-awards',
            {
                duration: 0.5,
                ease: 'circ.out',
                opacity: 1,
                y: 0,
            },
            '-=0.25'
        );
        showModalTeam.to(
            '#modal-team-bio',
            {
                duration: 0.5,
                ease: 'circ.out',
                opacity: 1,
                y: 0,
            },
            '-=0.25'
        );
    }

    // ---------------------------------------------------------------------------------------------------- Loading

    if (almBlock) {
        window.almComplete = function () {
            const videos = document.querySelectorAll(
                '.listing-posts-item video'
            );
            videos.forEach((video) => {
                video.load();
                video.play();
            });
        };

        // When ALM has loaded, refresh masonry and scroll to anchor
        window.almDone = function () {
            refreshMasonry();
            scrollToAnchor();
        };
    } else {
        // Scroll to anchor on page load (if an ALM block is not present)
        scrollToAnchor();
    }

    // ---------------------------------------------------------------------------------------------------- Scrolling

    document.querySelectorAll('.scrollto').forEach((anchor) => {
        anchor.addEventListener('click', function (e) {
            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth',
            });
            e.preventDefault();
        });
    });

    // Makes sure anchor links in the secondary menu still work if you're on the page the anchor is on
    document.querySelectorAll('.menu-secondary a').forEach((anchor) => {
        anchor.addEventListener('click', function (e) {
            const href = this.getAttribute('href');
            const url = new URL(href, location.origin);

            if (url.pathname === location.pathname && url.hash) {
                menuToggle.click();
                document.querySelector(url.hash).scrollIntoView({
                    behavior: 'smooth',
                });
                e.preventDefault();
            }
        });
    });

    // ---------------------------------------------------------------------------------------------------- Menu toggle, modal

    if (menuToggle) {
        // Menu toggle

        menuToggle.addEventListener('click', () => {
            toggleButtonMenu();
            scrollYSave();

            // If the team modal is on the page and is active
            if (modalTeam && modalTeam.classList.contains('active')) {
                // Team modal
                toggleModalTeam();
                togglePageContent();
                scrollYRestore();
                togglePageHeaderState();

                mm.add('(prefers-reduced-motion: no-preference)', () => {
                    showModalTeam.restart();
                    showModalTeam.pause();
                });
            } else {
                // Main menu
                header.classList.toggle('!tw-bg-transparent');
                menuBg.classList.toggle('tw-hidden');
                menuContainer.classList.toggle('tw-hidden');

                mm.add('(prefers-reduced-motion: no-preference)', () => {
                    if (menuToggle.classList.contains('active')) {
                        showMenu.play();
                    } else {
                        togglePageContent();
                        scrollYRestore();
                        togglePageHeaderState();
                        showMenu.restart();
                        showMenu.pause();
                    }
                });

                mm.add('(prefers-reduced-motion: reduce)', () => {
                    togglePageContent();
                    if (!menuToggle.classList.contains('active')) {
                        scrollYRestore();
                    }
                    togglePageHeaderState();
                });
            }
        });

        /* Modal */

        if (modalTeam) {
            document.querySelectorAll('.team-member').forEach((el) => {
                el.addEventListener('click', function (e) {
                    toggleButtonMenu();
                    scrollYSave();
                    toggleModalTeam();

                    let teamMember = el.closest('.team-member');

                    document.getElementById('modal-team-awards').innerHTML =
                        teamMember.dataset.awards;
                    document.getElementById('modal-team-bio').innerHTML =
                        teamMember.dataset.bio;
                    document.getElementById('modal-team-education').innerHTML =
                        teamMember.dataset.education;
                    document
                        .getElementById('modal-team-image')
                        .setAttribute('alt', teamMember.dataset.name);
                    document
                        .getElementById('modal-team-image')
                        .setAttribute('src', teamMember.dataset.image);
                    document.getElementById('modal-team-name').innerHTML =
                        teamMember.dataset.name;
                    document.getElementById('modal-team-position').innerHTML =
                        teamMember.dataset.position;

                    mm.add('(prefers-reduced-motion: no-preference)', () => {
                        showModalTeam.play();
                    });

                    mm.add('(prefers-reduced-motion: reduce)', () => {
                        togglePageContent();
                        togglePageHeaderState();
                    });

                    // If the window is portrait, jump to the top
                    if (window.innerHeight > window.innerWidth) {
                        document.getElementById('top').scrollIntoView({
                            behavior: 'instant',
                        });
                    }

                    menuToggle.focus(); // Pass focus to menu button so it's easy for keyboard users to dismiss modal

                    e.preventDefault();
                });
            });
        }
    }

    // Close menu on wider screens

    window.addEventListener('resize', () => {
        if (
            window.innerWidth >= 1024 &&
            menuToggle.classList.contains('active')
        ) {
            menuToggle.click();
        }
    });

    // ---------------------------------------------------------------------------------------------------- Secondary menu

    document
        .querySelectorAll('.menu-primary > .menu > .menu-item-has-children > a')
        .forEach((el) => {
            el.addEventListener('click', function (e) {
                if (
                    !this.closest('.menu-item').classList.contains(
                        'menu-item-has-children-active'
                    )
                ) {
                    document
                        .querySelectorAll('.menu-item-has-children-active')
                        .forEach((el) => {
                            el.classList.remove(
                                'menu-item-has-children-active'
                            );
                        });

                    this.closest('.menu-item').classList.add(
                        'menu-item-has-children-active'
                    );

                    document
                        .querySelectorAll('.sub-menu-active')
                        .forEach((el) => {
                            el.classList.remove('sub-menu-active');
                        });

                    let subMenuActive = indexInParent(el.closest('li')) + 1;

                    menuSecondary
                        .querySelectorAll(
                            '.menu-item:nth-child(' + subMenuActive + ')'
                        )
                        .forEach((el) => {
                            el.classList.add('sub-menu-active');
                        });

                    e.preventDefault();
                }
            });
        });

    // ---------------------------------------------------------------------------------------------------- Accordions

    if (accordionInstances) {
        document.querySelectorAll('.accordion-heading a').forEach((el) => {
            el.addEventListener('click', function (e) {
                let accordion = el.closest('.accordion');

                accordion.classList.toggle('accordion-active');
                accordion
                    .querySelector('.accordion-heading-icon')
                    .classList.toggle('tw-rotate-180');
                accordion
                    .querySelector('.accordion-copy')
                    .classList.toggle('tw-animate-fadein');
                accordion
                    .querySelector('.accordion-copy')
                    .classList.toggle('tw-hidden');

                e.preventDefault();
            });
        });
    }

    // ---------------------------------------------------------------------------------------------------- Filters

    const navigationOverlay = document.getElementById('navigation-overlay');
    const navigationOverlayButtons = document.querySelectorAll(
        '.navigation-overlay-button'
    );

    if (navigationOverlay) {
        navigationOverlayButtons.forEach((navigationOverlayButton) => {
            navigationOverlayButton.addEventListener('click', function (e) {
                e.stopPropagation(); // Prevents click bubbling up to the document, preventing conflicts with outside clicks
                document.getElementById('top').scrollIntoView({
                    behavior: 'smooth',
                });
                navigationOverlay.classList.toggle('tw-animate-slidein');
            });
        });

        const outsideNavigationOverlayCheck = function (event) {
            if (!event.target.closest('#navigation-overlay')) {
                navigationOverlay.classList.remove('tw-animate-slidein');
            }
        };

        document.addEventListener(
            'click',
            outsideNavigationOverlayCheck,
            false
        );
    }

    // ---------------------------------------------------------------------------------------------------- Scroll animations

    function animateFadeInItems() {
        mm.add('(prefers-reduced-motion: no-preference)', () => {
            // Fade in items

            const fadeInItemsInstances =
                document.querySelectorAll('.fade-in-items');

            if (fadeInItemsInstances) {
                fadeInItemsInstances.forEach((fadeInItemsInstance) => {
                    let fadeInItems =
                        fadeInItemsInstance.querySelectorAll('.fade-in-item');

                    fadeInItems.forEach((fadeInItem) => {
                        fadeInItem.style.cssText =
                            'opacity: 0; transform: translateY(2rem);';
                    });

                    ScrollTrigger.create({
                        markers: false,
                        once: true,
                        scroller: 'body',
                        start: 'top 70%',
                        trigger: fadeInItemsInstance,
                        onEnter: () => {
                            fadeInItems =
                                fadeInItemsInstance.querySelectorAll(
                                    '.fade-in-item'
                                );

                            gsap.to(fadeInItems, {
                                duration: 0.2,
                                autoAlpha: 1,
                                stagger: 0.1,
                                y: 0,
                            });
                        },
                    });
                });
            }

            // Scale in items

            const scaleInItemsInstances =
                document.querySelectorAll('.scale-in-items');

            if (scaleInItemsInstances) {
                scaleInItemsInstances.forEach((scaleInItemsInstance) => {
                    let scaleInItems =
                        scaleInItemsInstance.querySelectorAll('.scale-in-item');

                    scaleInItems.forEach((scaleInItem) => {
                        scaleInItem.style.cssText =
                            'opacity: 0; transform: scale(0.1);';
                    });

                    ScrollTrigger.create({
                        markers: false,
                        once: true,
                        scroller: 'body',
                        start: 'top 70%',
                        trigger: scaleInItemsInstance,
                        onEnter: () => {
                            gsap.to(scaleInItems, {
                                autoAlpha: 1,
                                duration: scaleInItemsInstance.dataset.duration,
                                ease: 'circ.out',
                                stagger: scaleInItemsInstance.dataset.stagger,
                                scale: 1,
                            });
                        },
                    });
                });
            }
        });
    }

    animateFadeInItems();

    // ---------------------------------------------------------------------------------------------------- Sticky header

    // Initial load
    togglePageHeaderState();

    window.addEventListener('scroll', () => {
        if (menuContainer.classList.contains('tw-hidden')) {
            togglePageHeaderState();
        }
        if (modalTeam && modalTeam.classList.contains('tw-hidden')) {
            togglePageHeaderState();
        }
    });

    // ---------------------------------------------------------------------------------------------------- Ajax / Team

    const loadingTeamMessage =
        '<div class="tw-px-5 tw-py-10 xl:tw-py-16 md:tw-px-pageindent 2xl:tw-container"><div class="tw-font-replicalight tw-text-center tw-text-gunmetal tw-text-2xl">Loading...</div></div>';

    function loadTeamDetail(container, teamLink) {
        containerTeam.innerHTML = loadingTeamMessage;

        fetch(listingAjax.ajaxUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'load_team_detail',
                nonce: listingAjax.nonces.detail,
                post_id: teamLink.dataset.teamId,
            }),
        })
            .then((r) => r.text())
            .then((data) => {
                container.innerHTML = data;
                document.getElementById('top').scrollIntoView({
                    behavior: 'smooth',
                });
                animateFadeInItems();
            });
    }

    function loadTeamListing(container, scrollto) {
        containerTeam.innerHTML = loadingTeamMessage;

        fetch(listingAjax.ajaxUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'load_team_listing',
                listing_per_page: containerTeam.dataset.listingPerPage,
                listing_template: containerTeam.dataset.listingTemplate,
                nonce: listingAjax.nonces.listing,
                post_type: containerTeam.dataset.postType,
            }),
        })
            .then((r) => r.text())
            .then((data) => {
                containerTeam.innerHTML = data;
                if (scrollto) {
                    document.getElementById('top').scrollIntoView({
                        behavior: 'smooth',
                    });
                }
                animateFadeInItems();
            });
    }

    if (containerTeam) {
        loadTeamListing(false, false); // Request listing on page load, without scrolling to accordion

        containerTeam.addEventListener('click', function (e) {
            const teamBack = e.target.closest('.back-to-team');
            const teamLink = e.target.closest('.listing-team-item');

            if (teamBack) {
                e.preventDefault();
                loadTeamListing(containerTeam, true);
            }

            if (teamLink) {
                e.preventDefault();
                loadTeamDetail(containerTeam, teamLink);
            }
        });
    }

    // ---------------------------------------------------------------------------------------------------- Project tabs

    const projectTabs = document.getElementById('project-tabs');
    const projectTabsContentItems = document.querySelectorAll(
        '.project-tabs-content'
    );
    const projectTabsItems = document.querySelectorAll('.project-tabs-item');

    if (projectTabs) {
        projectTabs
            .querySelector('.project-tabs-item:first-child button')
            .classList.add('active');

        projectTabsCurrent = projectTabs.querySelector(
            '.project-tabs-item:first-child button'
        ).dataset.target;

        document
            .getElementById(projectTabsCurrent)
            .classList.add('tw-animate-fadein');
        document
            .getElementById(projectTabsCurrent)
            .classList.remove('tw-hidden');
    }

    if (projectTabsItems) {
        projectTabsItems.forEach((projectTabsItem) => {
            projectTabsItem
                .querySelector('button')
                .addEventListener('click', function (e) {
                    document
                        .querySelectorAll('.project-tabs-item button.active')
                        .forEach((el) => {
                            el.classList.remove('active');
                        });

                    projectTabsContentItems.forEach((el) => {
                        el.classList.remove('tw-animate-fadein');
                    });
                    projectTabsContentItems.forEach((el) => {
                        el.classList.add('tw-hidden');
                    });

                    projectTabsItem
                        .querySelector('button')
                        .classList.add('active');

                    document
                        .getElementById(
                            projectTabsItem.querySelector('button').dataset
                                .target
                        )
                        .classList.add('tw-animate-fadein');
                    document
                        .getElementById(
                            projectTabsItem.querySelector('button').dataset
                                .target
                        )
                        .classList.remove('tw-hidden');
                });
        });
    }

    // ---------------------------------------------------------------------------------------------------- Swiper

    function getBool(val) {
        return !!JSON.parse(String(val).toLowerCase());
    }

    const navigationCarousel = document.getElementById('navigation-carousel');

    if (navigationCarousel) {
        const slides = navigationCarousel.querySelectorAll('.swiper-slide');
        const currentIndex = Array.from(slides).findIndex((el) =>
            el.classList.contains('current_page_item')
        );

        if (currentIndex !== -1) {
            navigationCarousel.dataset.start = currentIndex;
        }

        let swiper = new Swiper(navigationCarousel, {
            allowTouchMove: true,
            slidesPerView: 'auto',
            centeredSlides: getBool(navigationCarousel.dataset.centred),
            initialSlide: Number(navigationCarousel.dataset.start) || 0,
            loop: true,
            spaceBetween: 32,
        });
    }
});

// Page fully loaded
window.addEventListener('load', () => {});
